import { RescheduleAppointment } from '../gqlSchemes/rescheduleAppointment';
import { actions as calendarActions } from '../../../services/calendar';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { useMutation } from '@apollo/client';
import { GET_CALENDAR } from '../gqlSchemes/getCalendar';

const useRescheduleAppointment = () => {
  const dispatch = useDispatch();

  const [rescheduleAppointment] = useMutation(RescheduleAppointment);
  const [
    loadingRescheduleAppointment,
    setLoadingRescheduleAppointment,
  ] = useState({
    loadingReschedule: false,
    id: '',
  });

  const onRescheduleAppointment = async (
    event: any,
    selectedTime: { startDate: Date; endDate: Date },
    userId: [string],
    planifiedDuration: string
  ) => {
    setLoadingRescheduleAppointment({
      id: event.id,
      loadingReschedule: true,
    });

    const rescheduleAppointmentResponse = await rescheduleAppointment({
      variables: {
        //@ts-ignore
        record: {
          id: event.id,
          planifiedDuration,
          startDate: selectedTime?.startDate?.toISOString(),
          practitionerIds: userId,
          reservationModeId: event.reservationModeId,
          roomId: event.roomId,
        },
      },
      refetchQueries: [GET_CALENDAR],
    });

    //@ts-ignore
    if (
      rescheduleAppointmentResponse?.data?.schedule?.rescheduleAppointment?.ok
    ) {
      const data = {
        ...rescheduleAppointmentResponse?.data?.schedule?.rescheduleAppointment
          ?.result,
        startDate:
          rescheduleAppointmentResponse?.data?.schedule?.rescheduleAppointment
            ?.result?.startDate,
        endDate:
          rescheduleAppointmentResponse?.data?.schedule?.rescheduleAppointment
            ?.result?.endDate,
      };

      dispatch(calendarActions.updateEvent({ data }));

      setLoadingRescheduleAppointment({
        id: event.id,
        loadingReschedule: false,
      });
    }
  };
  return {
    onRescheduleAppointment,
    loadingRescheduleAppointment,
  };
};

export default useRescheduleAppointment;
